"use client";
import { j as l } from "./index.es52.js";
import { forwardRef as d, useMemo as p } from "react";
import { makeUniqueId as h, composeClassNames as u } from "./index.es184.js";
import j from "./index.es185.js";
d(
  ({
    children: n,
    state: e,
    message: s,
    isDisabled: c = !1,
    label: r = null,
    name: m = null,
    onChange: o = null,
    inputId: a,
    ...t
  }, b) => {
    const i = p(() => h(), []);
    return /* @__PURE__ */ l.jsxs("div", { className: "bl-select", children: [
      /* @__PURE__ */ l.jsx(
        "label",
        {
          className: "bl-select__label bl-size-6 bl-display-block bl-p-b-1",
          htmlFor: a || i,
          children: r
        }
      ),
      /* @__PURE__ */ l.jsxs("div", { className: "bl-select__icon-wrapper", children: [
        /* @__PURE__ */ l.jsx("i", { className: "bl-select__icon bl-icon--chevron-down bl-icon--small" }),
        /* @__PURE__ */ l.jsx(
          "select",
          {
            ...t,
            ref: b,
            id: a || i,
            name: m,
            disabled: c,
            className: u(
              "bl-input",
              e && `bl-input--${e}`
            ),
            onChange: o,
            children: n
          }
        )
      ] }),
      s && /* @__PURE__ */ l.jsx("div", { className: "bl-p-t-1", children: /* @__PURE__ */ l.jsx(j, { state: e, children: s }) })
    ] });
  }
);
//# sourceMappingURL=index.es58.js.map
